// extracted by mini-css-extract-plugin
module.exports = {"tempHeader":"TemporaryBlankHeader_tempHeader__q_Xjz","logoImage":"TemporaryBlankHeader_logoImage__2VfV6"};